/*
 * @Description: 推荐信息流配置
 * @Author: lmj limengjuan@36kr.com
 * @Date: 2021-06-15 18:48:11
 * @LastEditors: lmj limengjuan@36kr.com
 * @LastEditTime: 2023-08-21 15:16:30
 */
import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default [
    {
      exact: true,
      path: '/home/polymerize/flowConfig',
      owner: '/home',
      authority: 'recommendFlowConfig',
      component: Loadable({
        loader: () => import('./index'),
        loading: () => <RouteLoading />
      })
    }
  ];